import CartsStatsPage from './pages/CartsStats.page';
import CartsFlowPage from './pages/CartsFlow.page';
import CartDetailsPage from './pages/CartDetails.page';

CartsStatsPage.path = '/carts/stats';
CartsFlowPage.path = '/carts/flow';
CartDetailsPage.path = '/carts/:id';

export default {
  pages: {
    CartsStatsPage,
    CartsFlowPage,
    CartDetailsPage,
  }
};
